<app-header></app-header>
<app-sidebar></app-sidebar>
<ngx-spinner
  bdColor="rgba(51,51,51,0.8)"
  size="medium"
  color="#fff"
  type="ball-scale-multiple"  >
  <p style="font-size: 20px; color: white">{{'messages.loadingList' | translate}}</p>
</ngx-spinner>
<div class="main-content">
  <div class="page-content">
    <div class="container-fluid">
      <!-- start page title -->
      <div class="row">
        <div class="col-12">
          <div class="page-title-box d-flex align-items-center justify-content-between">
            <h4 class="mb-0 font-size-18">
              <i class="bx bx-home-circle"></i>  {{'dashboard.welcome' | translate}}
              <app-fildariane></app-fildariane>
            </h4>
            <div class="page-title-right">
              <ol class="breadcrumb m-0">
                <li class="breadcrumb-item"><a href="javascript: void(0);">{{'navigation.home' | translate}}</a></li>
                <li class="breadcrumb-item active">{{'pages.manageCertificatesByVerification' | translate}}
                </li>
              </ol>
            </div>
          </div>
        </div>
      </div>
      <!-- end row -->

    </div>
    <br>

    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">{{'pages.listVerifications' | translate}} ({{count_verif}})</h4>

            <div class="table-responsive">
              <table class="table mb-0">
                <thead>
                <tr>
                  <th>ID</th>
                  <th>{{'fields.labels' | translate}}</th>
                  <th>{{'common.actions' | translate}}</th>
                </tr>
                </thead>
                <tbody>
                <tr *ngFor="let c of list_verifications">
                  <th scope="row">{{c.id}}</th>
                  <td>{{c.name}}</td>
                  <td>
                    <a href="/dashboard/administrator/verification/editer/{{c.id}}"><i class="bx bx-edit"></i>{{'common.edit' | translate}}</a>
                  </td>
                </tr>
                </tbody>
              </table>

            </div>

          </div>
        </div>
      </div>
      <!-- end row -->
      <!-- end row -->
    </div>
    <!-- container-fluid -->
  </div>
  <!-- End Page-content -->
  <app-footer></app-footer>
</div>
